var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHarvesting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 24,
    viewBox: "0 0 16 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.1848 14.3708C11.1848 14.3708 11.3868 12.9866 11.3137 12.7887C11.2613 12.5905 10.2715 10.6629 10.2715 10.6629L9.57996 14.3708H11.1848Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.39094 0L0.858416 6.59016L2.35804 14.3708H4.76534L4.74619 10.3477L2.0188 7.53435L5.25431 8.67153L7.78303 4.66329L6.62241 1.92711L8.98243 4.77903L5.84885 10.3669L6.37022 14.3708H8.77752L10.7428 4.89101L6.39094 0Z",
    fill: "current"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.3652 7.07538L15.1149 10.9026L13.5921 14.3708H11.9873L12.276 13.5365L14.0945 11.3811L11.9143 12.6421C11.4262 11.2926 11.1475 10.935 10.7384 9.79061L12.3652 7.07538Z",
    fill: "current"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.46447 15.1732H14.587C16.5401 16.3313 16.4093 19.0902 14.5555 19.9878H1.5556C-0.432938 18.9808 -0.565401 16.1066 1.4536 15.1743L1.46447 15.1732Z",
    fill: "current"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.12587 21.1965L3.96291 24H7.97509L8.43309 21.2036L7.16222 21.1887L6.57279 23.6528L5.70997 21.2058L3.12587 21.1965Z",
    fill: "current"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.57018 22.859L9.57996 24H11.9873L12.6458 21.1962L11.6959 21.1886L11.2506 22.4788L11.1958 21.1977H9.08941C8.93433 21.7879 8.64998 22.3593 8.57018 22.859Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHarvesting);
export default __webpack_public_path__ + "static/media/Harvesting.d87fd888f6bab77761e31d7d51138cad.svg";
export { ForwardRef as ReactComponent };